// lib/basketQuantity.ts
// The card's quantity box for hosts that tell us what is ALREADY in the basket
// (syfak's `quantity` in ajax_get_prices, 2026-10-01 → NormalizedPrice.cartQuantity).
//
// syfak's flow-basket add (`cart.addLiveQuantity`) SETS the line, it does not add
// (tested on staging 2026-10-01: basket 1, send 2 → 2). So the box starts at the
// basket quantity and whatever it shows when clicked becomes the basket quantity
// — exactly how syfak's own category pages behave. Starting at 1 instead is what
// silently REDUCED orders (add 3, later add 2 → 2).
//
// Every host that does not send a quantity keeps today's behaviour: cartQuantity
// is undefined, the box starts at the default, the button keeps its label.

import type { NormalizedPrice } from '@/lib/pricing/externalPricing';

/** Where the quantity box starts: the basket quantity when known and > 0. */
export function startingQuantity(cartQuantity: number | undefined, defaultQuantity: number): number {
  return cartQuantity !== undefined && cartQuantity > 0 ? cartQuantity : defaultQuantity;
}

/** True when the host says this product is already in the basket. */
export function isInBasket(basketQuantity: number | undefined): boolean {
  return basketQuantity !== undefined && basketQuantity > 0;
}

/**
 * After a successful add, record the new basket quantity on the shared price
 * entry. Cards remount (grid↔list switch, pagination) and re-read the entry; a
 * stale pre-add value there would put the OLD number back in the box, and one
 * click would then cut the order. A fresh price fetch replaces the entry with
 * the host's own number. No-op for hosts that never sent a quantity.
 */
export function rememberBasketQuantity(entry: NormalizedPrice | null | undefined, quantity: number): void {
  if (entry && entry.cartQuantity !== undefined) entry.cartQuantity = quantity;
}
